export const INVITATION_STATUS_EXPIRE_AFTER_DAYS = 7
export const INVITATION_HARD_DELETE_AFTER_DAYS = 30

export const PENDING_INVITE_STATUSES = ['INVITED', 'PENDING']
export const EXPIRED_INVITE_STATUS = 'EXPIRED'

export function daysSinceInvite(inviteAt, now = new Date()) {
  if (!inviteAt) return null
  const inviteDate =
    inviteAt?.toDate?.() ||
    (inviteAt instanceof Date ? inviteAt : new Date(inviteAt))
  if (!inviteDate || Number.isNaN(inviteDate.getTime())) return null
  return (now - inviteDate) / (1000 * 60 * 60 * 24)
}

export function isInvitationPastExpireDays(inviteAt, now = new Date()) {
  const days = daysSinceInvite(inviteAt, now)
  if (days == null) return false
  return days >= INVITATION_STATUS_EXPIRE_AFTER_DAYS
}

export function isPendingInviteStatus(status) {
  return PENDING_INVITE_STATUSES.includes(status)
}

export function isExpiredInviteUser(user) {
  if (!user) return false
  if (user.status === EXPIRED_INVITE_STATUS) return true
  return (
    isPendingInviteStatus(user.status) &&
    isInvitationPastExpireDays(user.inviteAt)
  )
}
